// Generated by CoffeeScript 2.7.0
export var DurationThresholdSettingMixin = {
  props: {
    settingable: {
      type: Object
    },
    preventInitialize: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      value: {
        date: '',
        duration: ''
      },
      thresholdType: ''
    };
  },
  created: function() {
    if (!this.preventInitialize) {
      return this.$_init();
    }
  },
  methods: {
    checkedChangeFunc: function(event) {
      return this.thresholdType = event.target.checked ? event.target.value : '';
    },
    valueChangedFunc: function(value) {
      var result;
      result = value instanceof Date ? value.strftime('YYYY-MM-DD hh:mm') || '' : value;
      return this.value[this.thresholdType] = result;
    },
    destroyDateValue: function() {
      return this.value.date = '';
    },
    getValue: function() {
      if (!this.thresholdType) {
        return;
      }
      return {
        gid: this.settingable.gid,
        value: this.value[this.thresholdType]
      };
    },
    $_init: function() {
      var value;
      value = this.settingable.dig('settings', 'duration_threshold', 'value');
      if (!value) {
        return;
      }
      this.thresholdType = 'duration';
      return this.value[this.thresholdType] = value;
    }
  }
};

export var DurationThresholdSettingListMixin = {
  props: {
    settingables: {
      type: Array
    }
  },
  methods: {
    getData: function() {
      return _.compact(_.map(this.$refs.thresholdSettingCompRef, function(vm) {
        return vm.getValue();
      }));
    }
  }
};
